import { useTranslation } from "react-i18next";
import { NumericFormat as NumberFormat } from "react-number-format";
import ToolTip, { IconType } from "../../../../../components/ToolTip";
import { RowBody } from "../../../../../components/RowValue/RowBody";
import { decimalSeparator, thousandSeparator } from "../../../../../i18n";

export default function TestLoad({ value, set }) {
  const { t } = useTranslation("translation");

  function renderInput() {
    return (
      <NumberFormat
        className={"change-input"}
        decimalScale={2}
        value={value}
        thousandSeparator={thousandSeparator()}
        decimalSeparator={decimalSeparator()}
        displayType="input"
        type="text"
        onValueChange={(value) => set(value.floatValue)}
        allowNegative={false}
      />
    );
  }

  return (
    <RowBody
      titleValue={<p>{t("lvText.positionTestLoads.testLoad")}</p>}
      indicesValue={
        <span>
          P<sub>P</sub>
        </span>
      }
      inputValue={renderInput()}
      unitValue={"kN"}
      formulaValue={
        <ToolTip
          id={"testLoadInfoExpert"}
          type={IconType.INFO}
          text={t("lvText.positionTestLoads.testLoadInfoExpert")}
        />
      }
    />
  );
}
